
import {defineComponent} from "vue";
import TeamMember from "@/components/Member.vue";
import {WpApiMembers} from "@/types/WpApi";

declare let wpApiMembers: WpApiMembers;

export default defineComponent({
  name: "my-team",
  data() {
    return {
      membersByRole: wpApiMembers.members,
      chosenMemberRoleIds: wpApiMembers.chosenMemberRoleIds,
      allMemberRolesWithFields: wpApiMembers.allMemberRolesWithFields,
      memberRolesFiltered: wpApiMembers.memberRolesFiltered,
    };
  },
  computed: {},
  components: {TeamMember},
});
